var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5759",
    d: "M38.1,-63.6C50.5,-58.7,62.7,-51,70.9,-39.9C79.1,-28.8,83.3,-14.4,84.8,0.9C86.3,16.2,85.2,32.3,76.6,42.8C68.1,53.3,52.2,58.2,38.2,64.1C24.2,70.1,12.1,77.2,-1,78.9C-14.1,80.6,-28.2,76.9,-40.7,70.1C-53.2,63.2,-64.1,53.3,-73.5,41.1C-82.9,28.9,-90.8,14.4,-89.5,0.7C-88.2,-13,-77.8,-25.9,-66.6,-35C-55.4,-44,-43.3,-49.1,-32.1,-54.7C-20.9,-60.3,-10.4,-66.4,1.2,-68.4C12.8,-70.4,25.6,-68.4,38.1,-63.6Z",
    transform: "translate(100 100)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.a20d0ca2c096588143e51f7ff20c0602.svg";
export { ForwardRef as ReactComponent };